import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {TaskModel} from "../../../../../domain/models/task.model";
import {AccountModel} from "../../../../../domain/models/account.model";
import {AccountService} from "../../../../../domain/services/account/account.service";
import {PropertyResumeBarComponent} from "../../../../../common/property-resume-bar/property-resume-bar.component";
import {CustomerResumeBarComponent} from "../../../../../common/customer-resume-bar/customer-resume-bar.component";
import {MatIcon} from "@angular/material/icon";
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatOption} from "@angular/material/core";
import {MatSelect} from "@angular/material/select";
import {NgForOf, NgIf} from "@angular/common";
import {
  InactivatePropertyInfoComponent
} from "../../../../../common/inactivate-property-info/inactivate-property-info.component";
import {RentalPropertyInfoComponent} from "../../../../../common/rental-property-info/rental-property-info.component";
import {RentalPropertyModel} from "../../../../../domain/models/rental-property.model";
import {FormValidationUtil} from "../../../../../utils/form-validation.util";
import {TaskActionBarComponent} from "../task-action-bar/task-action-bar.component";

@Component({
  selector: 'app-inactivate-task-detail',
  standalone: true,
  imports: [
    CustomerResumeBarComponent,
    PropertyResumeBarComponent,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    MatOption,
    MatSelect,
    NgForOf,
    InactivatePropertyInfoComponent,
    RentalPropertyInfoComponent,
    MatError,
    NgIf,
    TaskActionBarComponent
  ],
  templateUrl: './inactivate-task-detail.component.html',
  styleUrl: './inactivate-task-detail.component.css'
})
export class InactivateTaskDetailComponent implements OnInit {
  @Input() currentTask!: TaskModel;
  @ViewChild(RentalPropertyInfoComponent) rentalPropertyInfoComponent!: RentalPropertyInfoComponent;
  disableSubmit = false;
  currentAccount: AccountModel | undefined;
  propertyToInactivate: RentalPropertyModel | undefined;
  contactInfoForm!: FormGroup;

  constructor(private readonly accountService: AccountService,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.fetchAccount();
  }

  private initForm(info: AccountModel) {
    this.contactInfoForm = this.fb.group({
      email: [info.email?? '', [Validators.required, Validators.email]],
      phone: new FormControl(info.phoneNumber??'', [
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(FormValidationUtil.getPhoneValidationPattern())
      ]),
    });
  }

  private fetchAccount(): void {
    const propertyId = this.currentTask.relatedEntityId;
    this.accountService.getByPropertyId(propertyId).subscribe(account => {
      this.currentAccount = account;
      this.propertyToInactivate = account.rentalProperty;
      this.initForm(account);
    });
  }

  isTaskApproved($event: boolean) {

  }
}
